<template>
  <el-col :xs="12" :sm="8" :md="8" :lg="7" :xl="5" class="center">
    <PrePostLimitCreditHistory ref="limitHistory" :customer="customer" />
    <span class="small">Meu limite de crédito {{ limit ? `(${limit})` : '' }}</span>&nbsp;
    <el-link class="small" @click="$refs.limitHistory.open()" type="primary">Ver Detalhes</el-link>
    <br />
    <el-progress :type="type" :text-inside="type === 'line'" :stroke-width="16"
      :text-color="type === 'line' ? '#fff' : 'rgb(96, 98, 102)'" :percentage="percentage"></el-progress>
    <el-tag type="success">Saldo disponível: <b>{{ balance  }}</b></el-tag>
  </el-col>
</template>

<script>
import { CustomerService } from "@/services/customers/customers.services";
import PrePostLimitCreditHistory from "./PrePostLimitCreditHistory.vue";

export default {
  name: "PrepostLimitCredit",
  props: ["type", "customer"],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      percentage: 0,
      limit: "",
      balance: "",
    };
  },
  methods: {
    fetch() {
      const vm = this;
      CustomerService.limit(vm.customer)
        .then((response) => {
          vm.limit = response.limit;
          vm.percentage = +response.percentage;
          vm.balance = response.balance;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    }
  },
  components: { PrePostLimitCreditHistory }
}
</script>

<style>
.center {
  text-align: center;
}
</style>
